import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Learning from './components/Learning';
import Certifications from './components/Certifications';
import Contact from './components/Contact';
import CollegeAchievements from './components/CollegeAchievements';
import Publications from './components/Publications';

function App() {
  return (
    <div className="App">
      <Navbar />
      
      {/* Add section wrappers with IDs that match navbar hrefs */}
      <section id="home">
        <Hero />
      </section>
      
      <section id="experience">
        <Experience />
      </section>
      
      <Projects />

      <Publications />
      
      <section id="skills">
        <Skills />
      </section>
      
      <section id="learning"> {/* If you want Learning in navbar, add it */}
        <Learning />
      </section>
      
      <section id="certifications">
        <Certifications />
      </section>
      
      <section id="college-achievements"> {/* THIS MATCHES YOUR NAVBAR HREF */}
        <CollegeAchievements />
      </section>
      
      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}

export default App;
